import React from 'react'

const RenderPageNumbers = ({totalPages , handlePageChange , currentPage}) => {
    const pageNumbers = [];
    const ellipsis = <span key={`ellipsis-${Math.random()}`} className="px-3 py-2 text-gray-500 dark:text-gray-400">...</span>;

    const getButtonClasses = (isActive) => {
        const baseClasses = "px-3 py-2 text-sm font-medium border rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2";
        
        if (isActive) {
            return `${baseClasses} bg-vox-green-600 border-vox-green-600 text-white shadow-lg hover:bg-vox-green-700 hover:border-vox-green-700`;
        } else {
            return `${baseClasses} bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600`;
        }
    };

    if (totalPages <= 7) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    className={getButtonClasses(i === currentPage)}
                >
                    {i}
                </button>
            );
        }
    } else {
        if (currentPage <= 4) {
            for (let i = 1; i <= 5; i++) {
                pageNumbers.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={getButtonClasses(i === currentPage)}
                    >
                        {i}
                    </button>
                );
            }
            pageNumbers.push(ellipsis);
            pageNumbers.push(
                <button 
                    key={totalPages} 
                    onClick={() => handlePageChange(totalPages)}
                    className={getButtonClasses(totalPages === currentPage)}
                >
                    {totalPages}
                </button>
            );
        } else if (currentPage >= totalPages - 3) {
            pageNumbers.push(
                <button 
                    key={1} 
                    onClick={() => handlePageChange(1)}
                    className={getButtonClasses(1 === currentPage)}
                >
                    1
                </button>
            );
            pageNumbers.push(ellipsis);
            for (let i = totalPages - 4; i <= totalPages; i++) {
                pageNumbers.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={getButtonClasses(i === currentPage)}
                    >
                        {i}
                    </button>
                );
            }
        } else {
            pageNumbers.push(
                <button 
                    key={1} 
                    onClick={() => handlePageChange(1)}
                    className={getButtonClasses(1 === currentPage)}
                >
                    1
                </button>
            );
            for (let i = currentPage - 2; i <= currentPage + 2; i++) {
                pageNumbers.push(
                    <button
                        key={i}
                        onClick={() => handlePageChange(i)}
                        className={getButtonClasses(i === currentPage)}
                    >
                        {i}
                    </button>
                );
            }
            pageNumbers.push(ellipsis);
            pageNumbers.push(
                <button 
                    key={totalPages} 
                    onClick={() => handlePageChange(totalPages)}
                    className={getButtonClasses(totalPages === currentPage)}
                >
                    {totalPages}
                </button>
            );
        }
    }

    return pageNumbers;
};

export default RenderPageNumbers
